import { cn } from "@/libs/utils";

const toPadding = (padding: number | string | number[]): string => {
  if (typeof padding === "string") {
    return padding;
  }
  if (Array.isArray(padding)) {
    const top = padding[0];
    const right = padding?.[1] ?? top;
    const bottom = padding?.[2] ?? top;
    const left = padding?.[3] ?? right;
    return `${top}px ${right}px ${bottom}px ${left}px`;
  }
  return `${padding}px`;
};

export function IconButton({
  icon,
  className = "",
  padding = 4,
  reverse = false,
  radius = 4,
  children,
  ...rest
}: {
  icon?: React.ReactNode;
  className?: string;
  reverse?: boolean;
  padding?: number | string | number[];
  radius?: number;
  children?: any;
} & any) {
  return (
    <div
      style={{
        padding: toPadding(padding),
        borderRadius: `${radius}px`,
      }}
      className={cn(className)}
      {...rest}
    >
      {reverse ? (
        <>
          {children}
          {icon}
        </>
      ) : (
        <>
          {icon}
          {children}
        </>
      )}
    </div>
  );
}
